<mat-option value="">None</mat-option>
<mat-option 
*ngFor="let department of departmentData"
[value]="department.key">{{ department.value }}
</mat-option>